/**
 * Gives a reasonable indication whether or not a variable of type `string` is probably
 * a GQL id from the mcs-backend Django ORM or not.
 *
 * This is helpful because GQL codegen maps the `ID` GQL scalar to typescript type `string`,
 * which can be confused
 *
 * This function DOES NOT guarantee type safety at compile time - e.g. you could still pass in the string
 * 'not-a-gql-id' into a mutation field that expects an ID, which would result in a runtime error.
 *
 * @param maybeGqlId a string that may or may not be a Graphql `ID` type
 * @returns whether or not the string is b64 encoded in the format `{django-model-name}Node:{pk}`
 */
export const doesStringLookLikeDjangoGqlId = (maybeGqlId: string): boolean => {
  let decoded = "";
  try {
    decoded = atob(maybeGqlId);
  } catch (e) {
    return false;
  }

  const parts = decoded.split(":");
  if (parts.length !== 2) {
    return false;
  }

  if (!parts[0].includes("Node")) {
    return false;
  }

  if (isNaN(parseInt(parts[1]))) {
    return false;
  }

  return true;
};
